import { Outlet, useRouter } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { useBoundStore } from '@Store/index.ts';
import { routesModel } from '@Router/router.consts';
import { LayoutsMap } from '@Router/router.types.ts';
import { PasswordlessDesktopSideBar } from '@Components/happyFlowTemplate/passwordlessDesktopSideBar/passwordlessDesktopSideBar';
import { BasicTemplate } from '@Layout/BasicTemplate.tsx';
import { EdgeCaseTemplate } from './EdgeCaseTemplate';
import { HappyFlowTemplate } from './HappyFlowTemplate';
import { EmptyTemplate } from './EmptyTemplate.tsx';

export const LayoutSwitcher = () => {
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());
  const [pathName, setPathName] = useState('');

  const router = useRouter();

  router.subscribe('onBeforeRouteMount', (route) => {
    setPathName(route.toLocation.pathname);
  });

  const activeLayoutType = useMemo(() => {
    const activeRoute = Object.values(routesModel).find((route) => pathName.includes(route.path));
    if (!activeRoute) return LayoutsMap.DEFAULT;
    else return activeRoute.layoutType;
  }, [pathName]);

  return (
    <>
      {activeLayoutType === LayoutsMap.DEFAULT && (
        <div
          key='default-layout'
          className='w-full h-full flex flex-row items-center fade-in overflow-scroll'>
          {isEmbedded && <PasswordlessDesktopSideBar />}
          <Outlet />
        </div>
      )}
      {activeLayoutType === LayoutsMap.HAPPY_FLOW && <HappyFlowTemplate />}
      {activeLayoutType === LayoutsMap.EDGE_CASE && <EdgeCaseTemplate />}
      {activeLayoutType === LayoutsMap.BASIC && <BasicTemplate />}
      {activeLayoutType === LayoutsMap.EMPTY && <EmptyTemplate />}
    </>
  );
};
